import React from "react";
import { TableContentForLeafCollectionSummary } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const columnNames = this.props.columnNames;
        const fieldDeductions = this.props.fieldDeductions;
        const factoryDedutions = this.props.factoryDedutions;

        return (
            <div>
                <h3><center><u>Leaf Collection Summary Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>

                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <table id="pdfTable" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th colSpan="2"></th>
                                        <th colSpan={2 + fieldDeductions.length} style={{ textAlign: "center" }}>Field Weight /Kg</th>
                                        <th colSpan={2 + factoryDedutions.length} style={{ textAlign: "center" }}>Factory Weight /Kg</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        {columnNames.map((x, index) => {
                                            return (
                                                <th key={index}>{x}</th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForLeafCollectionSummary
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}